<template>
  <div class="table-responsive">
    <table class="table table-striped table-sm">
      <thead>
      <tr>
        <th data-test="vendorPdtListingHead1"
												id="vendorPdtListingHead1">Product Id</th>
        <th data-test="vendorPdtListingHead2"
												id="vendorPdtListingHead2">Product Name</th>
        <th data-test="vendorPdtListingHead3"
												id="vendorPdtListingHead3">Brand</th>
        <th data-test="vendorPdtListingHead4"
												id="vendorPdtListingHead4">Price</th>
        <th data-test="vendorPdtListingHead5"
												id="vendorPdtListingHead5">Stock</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(product, index) in products"
          :key="product.product_id"
      >
        <td :data-test="'vendorPdtListingData1'+index"
												:id="'vendorPdtListingData1'+index">
          {{product.product_id}}
        </td>
        <td :data-test="'vendorPdtListingData2'+index"
												:id="'vendorPdtListingData2'+index">
          {{product.product_name}}
        </td>
        <td :data-test="'vendorPdtListingData3'+index"
												:id="'vendorPdtListingData3'+index">
          {{product.brand.brand_name}}
        </td>
        <td v-if="dataModal && dataModal[0] &&  dataModal[0].price"
												:data-test="'vendorPdtListingData4'+index"
												:id="'vendorPdtListingData4'+index">
          {{dataModal[0].price}}
        </td>
        <td v-else></td>
        <td v-if="dataModal && dataModal[0] &&
              dataModal[0].available_stock"
												:data-test="'vendorPdtListingData5'+index"
												:id="'vendorPdtListingData5'+index"
        >
          {{dataModal[0].available_stock}}
        </td>
        <td v-else></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { productApi } from '../../../../../services/ApiServices/productApi'

export default {
	computed: {
		...mapGetters('vendor', ['getVendorData'])
	},
	data () {
		return {
			products: Array,
			dataModal: Array
		}
	},
	mounted () {
		productApi.getAllProductsByVendor(this.getVendorData.user_name)
			.then((res) => {
				if (res.data && res.data[0] && res.data[0].inventories) {
					this.dataModal = Object.values(res.data[0].inventories)
				}
				this.products = res.data
			})
	}
}
</script>
